import React from 'react'
import GlistColumn from "../../manager/columns-manager/column";
import GenericListModule from "../../generic-list-module";
import {Aggregator} from "../../../../data-structures/aggregators/aggregator";
import {AggregatorValue} from "../../../../data-structures/aggregators/render/aggregator-value";

const debug = false
// const debug = "ListItemCell"

type Props = {
    column: GlistColumn,
    aggregator: Aggregator,
    module  : GenericListModule
}

export default function AggregationCell(props:Props) {

    const isTitle   = props.column.isTitle
    const isSticky  = isTitle && props.module.titleSticky


    const classes = Classes("cell", "aggregate", {
        // 'sticky'        : isSticky,
        // 'with-group-by' : !!this.props.module.groupBy,
        // 'is-first'      : this.props.isFirst,
        // 'is-last'       : this.props.isLast
    })

    const styles:any = {
        width   : props.column.width
    }
    // if (isSticky) {
    //     styles.left = this.props.module.skin.paddingLeft
    // }

    debug && console.log(debug, 'render')

    return (
        <div className={classes} style={styles}>
            {props.aggregator && <AggregatorValue aggregator={props.aggregator} /> }
            {/*{isSticky && <div className="sticky-shadow-emitter"/>}*/}
        </div>
    )

}

